import "./loader.scss";
import { useTranslation } from "react-i18next";
import { DomainName } from "../../utils/constants";
import { currentDomain } from "../../utils/general-config";

const ReactLoader = ({ showloader, isProcessing, color = "#2ebe6e" }) => {
  const { t } = useTranslation();
  const domain = currentDomain().toLowerCase();

  const domainColorMap = {
    [DomainName.PDFSIMPLI]: "#FC742F",
    [DomainName.SIGNSIMPLI]: "#2e68b1",
    [DomainName.LEGALSIMPLI]: "#dd7731",
  };

  color = domainColorMap[domain] || "#2ebe6e";
  return (
    <div className={`react-loader ${showloader}`} style={{ "--loader-color": color }}>
      <div className="flex items-center justify-center">
        <div className="flex flex-col justify-center items-center">
          {isProcessing && (
            <div className="mt-72 text-sm md:text-base lg:text-lg font-semibold text-gray-700">
              {t("loader.processing_message")}
            </div>
          )}
          <div className="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReactLoader;
